export default {
    addAlbum: {
        method: 'POST',
        url: '/manage-system/album',
        name: '新增相册'
    },
    getIcon: {
        method: 'POST',
        url: '/manage-system/album/icon',
        name: '获取相册图标'
    },
    getAlbum: {
        method: 'GET',
        url: '/manage-system/album',
        name: '获取相册'
    },
    editAlbum: {
        method: 'PUT',
        url: '/manage-system/album',
        name: '编辑相册'
    },
    deleteAlbum: {
        method: 'DELETE',
        url: '/manage-system/album',
        name: '删除相册'
    },
    batchAddResource: {
        method: 'POST',
        url: '/manage-system/album/batchAddResource',
        name: '批量上传图片'
    },
    batchDeleteResource: {
        method: 'POST',
        url: '/manage-system/album/batchDeleteResource',
        name: '批量删除图片'
    },
    batchUpdateResource: {
        method: 'POST',
        url: '/manage-system/album/batchUpdateResource',
        name: '批量编辑图片'
    },
    orderAlbum: {
        method: 'PUT',
        url: '/manage-system/album/order',
        name: '修改相册顺序'
    },
    orderResource: {
        method: 'PUT',
        url: '/manage-system/album/orderResource',
        name: '编辑相册资源'
    },
    getResource: {
        method: 'POST',
        url: '/manage-system/album/resource',
        name: '获取相册资源'
    },
    getAlbumDetail: {
        method: 'GET',
        url: '/manage-system/album/{id}',
        name: '获取相册详情'
    },
    batchOrder: {
        method: 'PUT',
        url: '/manage-system/album/batchOrder',
        name: '批量直接修改相册顺序'
    },
    batchOrderResource: {
        method: 'POST',
        url: '/manage-system/album/batchOrderResource',
        name: '批量直接修改顺序相册资源'
    },
}